import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const OrganizationTypeStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OrganizationTypeContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <OrganizationTypeStateContext.Provider value={stateHook}>
      {children}
    </OrganizationTypeStateContext.Provider>
  );
};

export default OrganizationTypeContextProvider;